import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AnsokanFormGroupService } from 'src/app/service/ansokan-form-group/ansokan-form-group.service';
import { UtilityService } from 'src/app/service/utility/utility.service';
import { DocumentUtil } from 'src/app/util/document-util';

@Component({
    selector: 'app-confirmation',
    styleUrls: ['./confirmation.component.scss'],
    templateUrl: './confirmation.component.html',
    standalone: false
})
export class ConfirmationComponent implements OnInit {

  public dnr: string;
  public applicantSsn: string;
  public applicantEmail: string;

  constructor(
    private groupService: AnsokanFormGroupService,
    private utilityService: UtilityService,
  ) { }

  public ngOnInit() {
    const application = this.groupService.value;
    this.groupService.setFormGroup(null);
    if (application) {
      this.applicantEmail = application.applicant.applicantEmail;
      this.applicantSsn = application.applicantSsn;
      this.dnr = application.skolverketCaseId;
    }
  }

  public openFlyleafPdf(): void {
    this.utilityService.generateFlyleafDocument(this.dnr, this.applicantSsn)
      .pipe(tap((result) => result.fileName = `Försättsblad_${this.dnr}.pdf`))
      .subscribe((result) => DocumentUtil.displayDocument(result.content, result.fileName));
  }
}
